<template>
  <div id="AssignAgentAdmin" class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="pageTitle">Assign {{ user.name }}</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-header">To Subcategory(ies)</div>
          <div class="card-body">
            <div class="row">
              <div class="col">
                <label>Categories</label>
                <select @change="changeTopCategory($event)" class="form-control">
                  <option value>Select...</option>
                  <option v-for="(cat, index) in categories" :key="index" :value="index">{{ cat.name }}</option>
                </select>
                <label class="mt-4">Subcategories</label>
                <select v-model="choosenSub" class="form-control mySelect" multiple>
                  <option value>select...</option>
                  <option v-for="cat in subCategories" :key="cat.uuid" :value="cat.uuid">{{ cat.name }}</option>
                </select>
                <button @click="assign" class="btn btn-danger mt-4">Assign</button>
              </div>

              <div class="col"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'AssignAgentAdmin',

  data() {
    return {
      user: { role: {} },
      categories: [],
      subCategories: [],
      choosenSub: []
    }
  },

  mounted() {
    let loading = this.$loading.show()
    axios.get(`/admin/user/${this.$route.params.uuid}`).then(res => {
      this.user = res.data.user
      loading.hide()
    })
    axios.get('/admin/categories').then(res => {
      this.categories = res.data.categories
      loading.hide()
    })
  },

  methods: {
    changeTopCategory(e) {
      this.subCategories = this.categories[e.target.value].subcategories
      // console.log(this.categories);
      //console.log(this.subCategories);
    },

    assign() {
      let formData = new FormData()
      formData.append('subCategoriesUUID', JSON.stringify(this.choosenSub))
      formData.append('userUUID', this.$route.params.uuid)
      axios.post('admin/assign-agent', formData).then(res => {
        if (res.data.status == 'success') {
          this.$swal('', res.data.message, 'success')
          this.$router.push({ name: 'UserDetailsAdmin', params: { uuid: this.$route.params.uuid } })
        }
      })
    }
  },

  computed: {
    client() {
      return this.$store.state.client
    }
  },
  validations: {
    choosenSub: { required }
  }
}
</script>

<style scoped>
.mySelect {
  height: 400px !important;
}
</style>
